"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UploadFileModal", {
  enumerable: true,
  get: function get() {
    return _UploadFileModal.UploadFileModal;
  }
});
var _UploadFileModal = require("./UploadFileModal");